import React, {Component} from 'react';
import styles from '../css-modules/projectNav.module.scss';
import main from '../../resources/navbackgrounds/main.jpg';
import lums from "../../resources/lums_orig.png";
import { MdCancel } from "react-icons/md";
import {TweenMax, Power3} from 'gsap';
import { Link } from "react-router-dom";

class ProjectsNav extends Component {
  constructor(props) {
    super(props);
    this.navigation = React.createRef();
    this.fadeRef = React.createRef();
    this.delayedFade = React.createRef();
    this.state = {projectNavOpen: false}
  }

  openLink = (e, link) => {
    e.preventDefault();
    window.location = link;
  }

  render() {
    return (
      <div ref={this.navigation} className={styles.navContainer} style={{height: window.innerHeight}}>
        <Link to="home">
          <img src={lums} alt="Lahore University of Management Sciences" className={styles.lums_logo}/>
        </Link>
        <img src={main} alt="Photographic highlights from all projects" className={styles.absoluteBgMain}/>

        <div ref={this.fadeRef} style={{position: 'relative'}}>
          <p className={styles.browse_proj_heading}>Explore themes</p>
          <div className={styles.mobileChapterNavsContain}>
            <div className={styles.navItem}>
              <p className={styles.projectTitle}><span onClick={(e) => this.openLink(e, "https://archive.lums.edu.pk/interactives/political/home")} className={styles.underline}>Political movements in Lahore</span></p>
            </div>
            <div className={styles.navItem}>
              <p className={styles.projectTitle}><span onClick={(e) => this.openLink(e, "https://archive.lums.edu.pk/interactives/literature-lahore/home")} className={styles.underline}>Lahore’s literary landscape</span></p>
            </div>
            <div className={styles.navItem}>
              <p className={styles.projectTitle}><span onClick={(e) => this.openLink(e, "https://archive.lums.edu.pk/interactives/two-murders/home")} className={styles.underline}>Two murders, Two trials</span></p>
            </div>
            <div className={styles.navItem}>
              <p className={styles.projectTitle}><span onClick={(e) => this.openLink(e, "https://archive.lums.edu.pk/interactives/hindu/home")} className={styles.underline}>Re-imagining Lahore as a Hindu city</span></p>
            </div>
            <div className={styles.navItem}>
              <p className={styles.projectTitle}><span onClick={(e) => this.openLink(e, "https://archive.lums.edu.pk/interactives/mall-road/home")} className={styles.underline}>The Mall – history and culture, now and then</span></p>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default ProjectsNav;
